import axios from '../request/http.js'
import { handleGetRequestParams } from "@/common/js/utils.js";

class BillSearch {
  /* 获取报销单查询列表 */
  static getReimbursementList(options) {
    let url = `/zzd/api/back/order/reimbursement/page?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取预审批单查询列表 */
  static getPreliminaryList(options) {
    let url = `/zzd/api/back/order/pre/approval/page?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default BillSearch;